import ApplicationController from '../application-controller';

import verticalBorder from '~/../../snippets/mm-border--v-large.liquid?raw';
import horizontalBorder from '~/../../snippets/mm-border--h-large.liquid?raw';

export default class extends ApplicationController {
  declare observer?: MutationObserver;
  declare productPersonalizerNodeCache?: Element;

  connect() {
    super.connect();
    this.setupMutationObserver();
  }

  setupMutationObserver() {
    this.observer = new MutationObserver(this.onMutationObserved);
    this.observer.observe(this.element, { subtree: true, childList: true });
  }

  onMutationObserved: MutationCallback = (_, observer) => {
    if (this.productPersonalizerNode) {
      this.appendBorders();
      observer.disconnect();
    }
  };

  get productPersonalizerNode() {
    return (this.productPersonalizerNodeCache ||=
      this.element.getElementsByClassName('product-personalizer')[0]);
  }

  appendBorders() {
    const node = this.productPersonalizerNode;

    if (node) {
      [
        [verticalBorder, 'vertical', 'left', 'right'],
        [horizontalBorder, 'horizontal', 'top', 'bottom'],
      ].forEach(([svg, orientation, ...positions]) => {
        positions.forEach((position) => {
          const div = document.createElement('div');

          div.classList.add(
            'mm-border',
            `mm-border--${orientation}`,
            `mm-border--${position}`,
          );

          div.innerHTML = svg;

          node.appendChild(div);
        });
      });
    }
  }
}
